<template>
    <div class="md-nbr-form standard" :style="{ backgroundColor: bgColor }">
        <module-box
            class="form-container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <info-agent :agent="agent" :licenseName="licenseName"></info-agent>
            <div class="info-right">
                <div
                    v-if="title"
                    class="mg-title"
                    v-html="formatFontSize(title, '--mg-title-size')"
                ></div>
                <info-form
                    :registerRole="registerRole"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="newFormList"
                    :showTitle="false"
                    :defaultMsg="defaultMsg"
                    :submitText="submitText"
                    :submitStyle="{
                        backgroundColor: submitBgColor
                    }"
                    disclaimerColor="#a0a3af"
                    @done="handleShowToast"
                ></info-form>
            </div>
        </module-box>
        <div v-if="!user" ref="lineContent" class="line-content">
            <div
                ref="lineFormRef"
                class="line-form"
                :style="{ backgroundColor: bgColor }"
            >
                <div class="mg-container">
                    <info-agent
                        :agent="agent"
                        :licenseName="licenseName"
                    ></info-agent>
                    <div class="form-wrap">
                        <info-form
                            :registerRole="registerRole"
                            :questionnaire="questionnaire"
                            :onSubmitOption="onSubmitOption"
                            :formList="formList"
                            :showTitle="false"
                            :showLender="false"
                            :submitText="submitText"
                            :submitStyle="{
                                backgroundColor: submitBgColor
                            }"
                            disclaimerColor="#a0a3af"
                            :disclaimerTeleportId="disclaimerWrapRef"
                            @done="handleShowToast"
                        ></info-form>
                        <div class="nbr-form-disclaimer" :ref="onRef"></div>
                    </div>
                </div>
            </div>
            <div ref="linePlaceholderRef" class="line-placeholder"></div>
        </div>
    </div>
</template>
<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-nbr-form.standard {
    position: relative;
    width: 100%;
    background-color: #f8f9fd;
    ::-webkit-input-placeholder {
        letter-spacing: 0.2px;
    }
    ::-moz-placeholder {
        letter-spacing: 0.2px;
    }
    :-ms-input-placeholder {
        letter-spacing: 0.2px;
    }
    .form-container {
        display: none;
        align-items: center;
        &:not(.mg-container) {
            padding-left: 20px;
            padding-right: 20px;
        }
        .info-agent {
            position: relative;
            margin-right: 20px;
            display: flex;
            flex-direction: column;
            &:after {
                position: absolute;
                content: '';
                background: linear-gradient(
                    to top,
                    rgba(33, 33, 33, 0.5),
                    transparent
                );
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            .agent-image {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-bottom: 10px;
                img {
                    border-radius: 50%;
                }
            }
            .agent-detail {
                max-width: 180px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                white-space: nowrap;
                color: #fff;
                > p {
                    margin-top: 3px;
                }
                .name {
                    font-size: 16px;
                    line-height: 19px;
                    font-family: var(--font-bold);
                }
                .position,
                .phone {
                    margin-top: 4px;
                    font-size: 14px;
                    line-height: 17px;
                    @include ellipsis();
                }
                .position {
                    span {
                        white-space: nowrap;
                    }
                }
            }
        }
        .info-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            .mg-title {
                width: 100%;
                flex: none;
                font-size: var(--mg-title-size);
            }
            .info-form {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
            .input-content {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
            .basic-info {
                flex: none;
                display: flex;
                flex-wrap: wrap;
                margin-left: -20px;
                margin-top: -20px;
                .input-box {
                    flex-grow: 1;
                    min-width: 230px;
                    margin-left: 20px;
                    margin-top: 20px;
                    position: relative;
                    &.question {
                        width: calc(100% - 20px);
                        flex: none;
                    }
                }
                input {
                    display: inline-block;
                    font-size: 14px;
                    height: 45px;
                    background-color: #fff;
                    border: solid 1px var(--color-border);
                    width: 100%;
                    padding-left: 20px;
                }
                textarea {
                    width: 100%;
                    height: 100px;
                    border: solid 1px var(--color-border);
                    padding: 12px 20px;
                    font-size: 14px;
                }
            }
            .submit-content {
                flex: none;
                margin-top: 20px;
            }
            .agree-lender {
                margin-bottom: 20px;
                font-size: 14px;
                color: var(--color-disable);
                label {
                    display: flex;
                    align-items: center;
                    .agreement-txt {
                        @include ellipsis();
                    }
                }
                input[type='checkbox'] {
                    opacity: 0;
                    display: none;
                }
                .icon-checked {
                    display: inline-block;
                    text-align: center;
                    box-shadow: var(--box-shadow);
                    border: solid 1px var(--color-border);
                    line-height: 18px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                    font-size: 14px;
                    @include color-theme();
                    margin-right: 12px;
                    background-color: white;
                    &::before {
                        display: none;
                    }
                }
                input[type='checkbox']:checked + .icon-checked:before {
                    display: block;
                }
            }
            .submit {
                @include color-button-hover();
                display: inline-block;
                height: 45px;
                min-width: 120px;
                max-width: 100%;
                padding: 0 20px;
                text-align: center;
                vertical-align: middle;
                font-size: 14px;
                font-family: var(--font-bold);
                @include color-button();
            }
        }
    }
    .line-content {
        width: 100%;
        background-color: #fff;
        border: 1px solid #ebecf1;
        .mg-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .line-form {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 12px 0;
            .info-agent {
                margin-right: 20px;
                display: flex;
                flex-direction: column;
                .agent-image {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    margin-bottom: 10px;
                    img {
                        border-radius: 50%;
                    }
                }
                .agent-detail {
                    max-width: 180px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    white-space: nowrap;
                    .name {
                        font-size: 16px;
                        line-height: 19px;
                        font-family: var(--font-bold);

                        @include ellipsis();
                    }
                    .position {
                        display: none;
                    }
                    .phone {
                        margin-top: 4px;
                        font-size: 14px;
                        line-height: 17px;

                        color: var(--color-info);
                        @include ellipsis();
                    }
                }
            }
            .info-form {
                display: flex;
                .v-input .email-suggestion {
                    display: none;
                }
                .basic-info {
                    display: flex;
                }
                .input-box {
                    margin-right: 10px;
                    &.fullname {
                        min-width: 160px;
                    }
                    &.email {
                        min-width: 240px;
                    }
                    &.phone {
                        min-width: 200px;
                    }
                    input {
                        display: inline-block;
                        font-size: 12px;
                        height: 30px;
                        line-height: 22px;
                        background-color: #fff;
                        border: solid 1px var(--color-border);
                        width: 100%;
                        padding-left: 10px;
                    }
                }
                .submit-content {
                    min-width: 90px;
                    flex: none;
                    .submit {
                        @include color-button-hover();
                        width: 100%;
                        height: 30px;
                        text-align: center;
                        font-size: 14px;
                        font-family: var(--font-bold);
                        @include color-button();
                    }
                }
            }
            &.fixed {
                position: fixed;
                left: 0;
                bottom: 0;
                background-color: #fff;
                border: 1px solid #ebecf1;
                z-index: var(--level-sublow, 100);
                & + .line-placeholder {
                    display: block;
                }
            }
        }
        .line-placeholder {
            width: 100%;
            display: none;
        }
    }
    .mg-title {
        width: 100%;
    }
    @include media-1080 {
        .form-container {
            display: flex;
            .info-agent {
                margin-right: 30px;
                .agent-detail {
                    left: 11px;
                    right: 11px;
                }
            }
        }
        .line-content {
            display: none;
        }
    }
    @include media-800 {
        .form-container {
            flex-direction: column;
            .info-agent {
                margin-right: 0;
                margin-bottom: 20px;
                width: 100%;
                height: auto;
                flex-direction: row;
                &::after {
                    display: none;
                }
                .agent-image {
                    width: 80px;
                    height: 80px;
                    margin-right: 17px;
                    border-radius: 50%;
                    flex: none;
                    img {
                        border-radius: 50%;
                    }
                }
                .agent-detail {
                    position: static;
                    flex: 1;
                    .name {
                        font-size: 18px;
                        margin-top: 0;
                        line-height: 20px;
                        color: var(--color-text);
                    }
                    .position {
                        line-height: 150%;
                        margin-top: 4px;
                        color: var(--color-label);
                        span {
                            white-space: normal;
                        }
                    }
                    .phone {
                        line-height: 150%;
                        margin-top: 0;
                        color: var(--color-label);
                    }
                }
            }
        }
    }
    @include media-600 {
        ::-webkit-input-placeholder {
            font-size: 12px;
        }
        ::-moz-placeholder {
            font-size: 12px;
        }
        :-ms-input-placeholder {
            font-size: 12px;
        }
        .form-container {
            overflow: visible;
            &:not(.mg-container) {
                padding-left: 15px;
                padding-right: 15px;
            }
            .info-agent::after {
                display: block;
                background: #fff;
                top: auto;
                bottom: -20px;
                left: -15px;
                right: -15px;
                height: 1px;
            }
            .info-right {
                .mg-title {
                    padding-top: 20px;
                    letter-spacing: normal;
                }
                .basic-info {
                    margin-top: -10px;
                    .input-box {
                        margin-top: 10px;
                    }
                    input {
                        height: 40px;
                        line-height: 22px;
                    }
                    textarea {
                        height: 80px;
                    }
                }
                .submit-content {
                    margin-top: 12px;
                }
                .agree-lender {
                    label {
                        height: auto;
                    }
                }
                .submit {
                    height: 40px;
                    width: 100%;
                }
            }
        }
    }
    .disclaimer-wrap.opt-in {
        margin-top: 10px;
    }
}
</style>
